import { useRouteError } from 'react-router-dom'
import { isAxiosError } from 'axios'
import { Button } from '@/components/ui/button'

function NetworkError() {
  const handleReload = () => {
    window.location.reload()
  }
  return (
    <div className='flex max-w-md flex-col items-center justify-center space-y-6 mx-auto text-center w-full h-svh bg-background'>
      <h1 className='text-2xl font-bold'>Connection Error</h1>
      <p className='text-muted-foreground'>
        We are unable to connect to the server. Please check your internet connection and try again.
      </p>
      <Button onClick={handleReload}>Reload</Button>
    </div>
  )
}

export default function ErrorPage() {
  const error = useRouteError()

  if (import.meta.env.DEV) {
    // Intentional: log route errors for debugging when error boundary catches
    console.error(error)
  }

  if (isAxiosError(error) && error.code === 'ERR_NETWORK') {
    return <NetworkError />
  }

  return (
    <div className='flex max-w-md flex-col items-center justify-center space-y-6 mx-auto text-center w-full h-svh bg-background'>
      <h1 className='text-2xl font-bold'>Oops!</h1>
      <p className='text-muted-foreground'>Sorry, an unexpected error has occurred.</p>
    </div>
  )
}
